import { Fab, styled } from '@mui/material';

export const MuiCustomFabButton = styled(Fab, {
  shouldForwardProp: () => true,
})<{}>(() => ({}));
